import {Breadcrumbs} from '../breadcrumbs/breadcrumbs.comp';
import {ArticleList} from '../article-list/article-list.comp';
import {logger} from '../../../common/utils';
import {Loader} from '../../../common/loader.comp';
import {CategoryList} from '../category-list/category-list.comp';
import {BaseWidgetProps} from '../../widget-container';
import * as React from 'react';
import {EventType} from '../../../common/logger/event-type';

export type CategoryPageProps = {
	categoryId: string;
	baseConfig: BaseWidgetProps;
};

export class CategoryPage extends React.Component<CategoryPageProps, any> {
	state = {
		subCategories: [],
		articles: [],
		isLoadingArticleResults: false,
		categoryMap: {}
	};

	constructor (props: CategoryPageProps) {
		super(props);
	}

	componentDidMount () {
		this.getCategoryData(this.props.categoryId);
	}

	getCategoryData (categoryId: string) {
		const categoryMap = this.props.baseConfig.categoryMap;
		const selectedCategory = categoryMap[categoryId];
		const subCategories = selectedCategory.children;
		this.setState({ categoryMap, subCategories });
		if (subCategories.length === 0) {
			this.setState({ isLoadingArticleResults: true });
			this.props.baseConfig.kbApi.getArticlesByCategoryId(this.props.categoryId)
			.then((articles: any) => {
				this.setState({ isLoadingArticleResults: false });
				this.setState({ articles });
			})
			.catch((e: any) => {
				logger('Cannot search articles', e);
			});
		}

		this.props.baseConfig.logger.logEvent(EventType.CATEGORY_VIEW, {
			categoryId,
			categoryTitle: selectedCategory.name
		});
	}

	render () {
		const subCategories = this.state.subCategories;
		const articles = this.state.articles;
		const translate = this.props.baseConfig.translate;

		const categoriesList = () => (
			<div className='sub-categories-list'>
				<CategoryList categories={subCategories} goToState={this.props.baseConfig.widgetNavigator.goToState} />
			</div>
		);

		const emptyStateArticle = (
			<h3 className='no-article'>{translate('widget-ng.category-page.article-empty')}</h3>
		);

		const articlesComp = articles.length ? (
			<div className='category-articles'>
				<ArticleList articles={articles} goToState={this.props.baseConfig.widgetNavigator.goToState} withIcons={true} />
			</div>
		) : emptyStateArticle;

		const loadArticlesResultsComp = (
			<Loader className='inner-page' color={this.props.baseConfig.widgetConfig.appearance.brandColor}/>
		);
		const articlesOrLoaderComp = this.state.isLoadingArticleResults ? loadArticlesResultsComp : articlesComp;
		// const articlesOrLoaderComp = articlesComp;
		return (
			<div className='category-page kb-page'>
				<Breadcrumbs categoryId={this.props.categoryId} baseConfig={this.props.baseConfig} linkToCurrentCategory={false}/>
				{subCategories.length ? categoriesList() : articlesOrLoaderComp}
			</div>
		);
	}
}
